<template>
    <div >
      <Card>
            <p slot="title">
                Histori Surat Jalan
            </p>
            <Button 
              type="primary" 
              slot="extra"
              :loading="loadingSearch"
              @click="getReceived" 
              icon="ios-search" 
              size="small"  >
                <span v-if="!loadingSearch">Search</span>
                <span v-else>Wait.....</span>
            </Button>

            <div v-for="invoice in invoicesReceived">
              <Row>
                  <Col span="6"><Tag color="green">P.{{ invoice.containerCode }} - {{ invoice.containerLoadDate | showDateFormatted}}</Tag> </Col>
                  
                  <Col span="3">&nbsp;
                    <Poptip placement="top" trigger="hover" v-if="invoice.invoiceReceiveDos.length > 0">
                        <Button type="info" size="small">{{invoice.invoiceReceiveDos.length}}</Button>
                        <div class="api" slot="content">
                            <ul>
                                <b>{{ invoice.markingCode }}</b>
                                <li v-for="item in invoice.invoiceReceiveDos">
                                    - {{ item.notes }}
                                </li>
                            </ul>
                        </div>
                    </Poptip>                    
                  </Col>

                  <Col span="10">{{ invoice.markingCode }}</Col>

              </Row>              
            </div>
        </Card>
        
        
    </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'
import cInvoiceReceive from '@/components/invoice/cInvoiceReceive'
import moment from 'moment'

export default {
  components : {cInvoiceReceive},
  data: () => ({
    invoicesReceived : [],
    loadingSearch: false
  }),
  methods: {
      getReceived: function(){
        this.loadingSearch  = true;
        HTTP
          .get('invoice/received')
          .then(response => {

            this.invoicesReceived = []

            let invoicesReceived = [];        

            _.forEach(response.data, function(value) {
                let invoice = {
                    invoiceid : value.invoiceid,
                    containerCode : value.packaging_list.container_loading.containercode,
                    containerLoadDate : value.packaging_list.container_loading.loaddate,
                    markingCode : value.packaging_list.marking_minified.markingheadercode,
                    invoiceReceiveDos : value.invoice_receive_do
                }

                invoicesReceived.push(invoice);
            });

            this.invoicesReceived = invoicesReceived;
            
            this.loadingSearch  = false;
          })
          .catch(e => {
            this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
            });
          })
      }     
  },
  filters: {
    showDateFormatted : function(stringToFormat){
        let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
        return moment(dateToFormat).format("DD MMM YYYY")
    }    
  },
  created() {
    // this.getUnreceived();
  }
}

</script>
<style>

</style>



// WEBPACK FOOTER //
// InvoiceReceiveHistory.vue?13a91d26